import {createReducer} from 'util/redux';
import {
	fetchKostsAction,
	kostAuswertungCFDefResponseAction,
	kostSetLoadingAction,
	resetKostModelsAction,
	setKostFetchedAction,
	setKostSingleChoiceModeAction,
	setKostTemplateStrAction,
	setVisibleKostkeysAction,
} from 'module/Kost/action/KostAction';
import {CustomFieldTO, KostTO} from 'generated/JavaTO';
import _ from 'lodash';
import {templateModel} from 'module/selpan/impl/kost/model/KostUtil'
import {ById} from 'util/redux/ReduxHelperTypes'
import {appInitAction} from 'util/ReduxUtil'

interface KostState {
	byId: ById<KostTO>
	allIds: string[]
	visibleIds: string[]
	singleChoiceMode: boolean
	fetched: boolean
	loading: boolean
	templateString: string
	auswertungCFDefs?: CustomFieldTO[]
}

const DFLT: KostState = {
	byId: {},
	allIds: [],
	visibleIds: [],
	singleChoiceMode: false,
	fetched: false,
	loading: false,
	templateString: '0',
}

const KostReducer = createReducer<KostState>(DFLT, builder => builder
	.addCase(appInitAction, (state) => ({
		...state,
		fetched: false,
		loading: false,
	}))
	.addCase(resetKostModelsAction, (state, {payload}) => {
		const byId = _.keyBy(payload, 'costId')
		const allIds = payload.map(x => x.costId)
		if (!_.isEqual(allIds, state.allIds) || !_.isEqual(byId, state.byId)) {
			// better performance when using many kost entities
			state = {
				...state,
				byId,
				allIds,
				visibleIds: state.visibleIds.filter(kostkey => allIds.find(k => kostkey === k)),
			}
		}
		return state
	})
	.addCase(setVisibleKostkeysAction, (state, {payload}) => ({
		...state,
		visibleIds: _.isEqual(payload, state.visibleIds) ? state.visibleIds : payload,
	}))
	.addCase(setKostSingleChoiceModeAction, (state, {payload}) => ({
		...state,
		singleChoiceMode: payload,
	}))
	.addCase(fetchKostsAction, (state, {payload}) => ({
		...state,
		fetched: true,
		loading: true,
	}))
	.addCase(setKostFetchedAction, (state, {payload}) => ({
		...state,
		fetched: true,
		loading: false,
	}))
	.addCase(kostSetLoadingAction, (state, {payload}) => ({
		...state,
		loading: payload,
	}))
	.addCase(setKostTemplateStrAction, (state, {payload}) => {
		const s = payload || '';
		templateModel.set({templateString: s});
		return ({
			...state,
			templateString: s,
		})
	})
	.addCase(kostAuswertungCFDefResponseAction, (state, {payload}) => ({
		...state,
		auswertungCFDefs: payload,
	})),
)

export const KostReducerNS = {Kost: KostReducer}
export type KostStateType = { Kost: ReturnType<typeof KostReducerNS.Kost> }